'use client';

import { useMemo, useState, type ReactNode } from 'react';

export function DeveloperDetails(props: { title: string; children: ReactNode }) {
    const [open, setOpen] = useState(false);
    return <details onToggle={event => setOpen(event.currentTarget.open)} style={{ marginTop: 10 }}>
        <summary style={{ cursor: 'pointer', fontSize: 12 }}>{props.title}</summary>
        {open ? props.children : null}
    </details>;
}

export function DeveloperJsonContent(props: { value: unknown; label: string }) {
    const serialized = useMemo(() => {
        try {
            const text = JSON.stringify(props.value, null, 2);
            if (text === undefined) throw new Error('No JSON value is available.');
            return { text };
        } catch (failure) {
            console.error('[developer-overlay] JSON serialization failed:', failure);
            return { error: failure instanceof Error ? failure.message : String(failure) };
        }
    }, [props.value]);
    const [copyStatus, setCopyStatus] = useState<{ text: string; error?: string }>();
    const copy = async () => {
        if (serialized.text === undefined) return;
        try {
            await navigator.clipboard.writeText(serialized.text);
            setCopyStatus({ text: serialized.text });
        } catch (failure) {
            console.error('[developer-overlay] JSON copy failed:', failure);
            setCopyStatus({ text: serialized.text, error: failure instanceof Error ? failure.message : String(failure) });
        }
    };
    if (serialized.error) return <p role="alert">{serialized.error}</p>;
    const currentStatus = copyStatus?.text === serialized.text ? copyStatus : undefined;
    return <>
        <button type="button" onClick={() => void copy()} aria-label={`Copy ${props.label}${props.label.endsWith('JSON') ? '' : ' JSON'}`}
            style={{ marginTop: 6, padding: '5px 10px', background: 'rgba(255,255,255,0.14)',
                border: '1px solid rgba(255,255,255,0.22)', borderRadius: 6, color: 'inherit' }}>
            {currentStatus && !currentStatus.error ? 'Copied' : 'Copy'}
        </button>
        {currentStatus?.error ? <p role="alert">Copy failed: {currentStatus.error}</p> : null}
        <pre style={{ fontSize: 11, maxHeight: 240, overflow: 'auto' }}>{serialized.text}</pre>
    </>;
}

export function DeveloperJson(props: { title: string; value: unknown }) {
    return <DeveloperDetails title={props.title}>
        <DeveloperJsonContent value={props.value} label={props.title} />
    </DeveloperDetails>;
}
